import { alpha } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  fieldMD: {
    flex: '1 0 auto',
    
    marginTop: theme.spacing(1.7),
    '& .MuiAutocomplete-root': {
      minWidth: 468,
      width: '100%',
    },
  },
  fieldsRow: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    minWidth: '100%',
  },
  fieldPrefixPhone: {
    marginTop: theme.spacing(1.5),
    display:'flex',
    flex: '1 0 auto',
    '& .MuiInput-root': {
      marginTop: theme.spacing(0),
    },
  },
  fieldPrefixPhoneSelect: {
    minWidth: '80px !important',
    width: '80px !important',
  '&::before': {
    content: '""',
    position: 'absolute',
    right: theme.spacing(0),
    top: '50%',
    transform: 'translateY(-50%)',
    width: '1px',
    height: '60%',
    backgroundColor: alpha(theme.palette.neutral.lighter, 0.4),
    zIndex: 1,
  },

  '& .MuiAutocomplete-input:first-of-type': {
    padding: '10px !important'
  },
},
  container: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  infoText: {
    marginBottom: theme.spacing(2),
    color: theme.palette.neutral.dark,
  },
  infoText2: {
    color: theme.palette.neutral.dark,
  },
  icon: {
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
    color: '#A5A5A5',
  },
  characteristics: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    width: '100%',
  },
  characteristicItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: '#FAFAFA',
    borderRadius: theme.shape.borderRadius,
    flex: '1',
    maxWidth: '30%',
    margin: theme.spacing(0.5),
    boxSizing: 'border-box',
  },
  characteristicLabel: {
    color: '#A5A5A5',
  },
  form: {
    marginTop: theme.spacing(2),
    display: 'flex',
  },
  field: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(5),
  },
  field2: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(5),
    width:'145px !important'
  },
}))

export default useStyles
